/**
 * Segredo do link de definição de senha (item 4C, revisão do consultor).
 *
 * `capturarSegredoDoLink()` roda em `index.js` ANTES de o React montar: lê
 * o `#t=` de `/redefinir-senha` ou `/convite`, apaga o fragmento da barra na hora e guarda
 * o segredo só em memória (variável deste módulo). Assim:
 *   - nada que observe a navegação o vê (NAV-02);
 *   - o `StrictMode` (que executa inicializadores duas vezes) não o perde —
 *     a página só LÊ, com `obterSegredoDoLink()`, que não muda nada;
 *   - `descartarSegredoDoLink()` o apaga ao concluir, vencer ou desistir.
 */
const FORMATO = /^[A-Za-z0-9_-]{43}$/;
const PAGINAS_DO_LINK = ['/redefinir-senha', '/convite'];
let segredo = '';

export function capturarSegredoDoLink(janela = window) {
    const { pathname, hash } = janela.location;
    if (!PAGINAS_DO_LINK.includes(pathname) || !hash) return;
    const lido = new URLSearchParams(hash.replace(/^#/, '')).get('t') || '';
    janela.history.replaceState(null, '', pathname);
    segredo = FORMATO.test(lido) ? lido : '';
}

export function obterSegredoDoLink() {
    return segredo;
}

export function descartarSegredoDoLink() {
    segredo = '';
}
